var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 188.96 50.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#New_Gradient_Swatch-8);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#New_Gradient_Swatch-6);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#New_Gradient_Swatch-7);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#New_Gradient_Swatch-4);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#New_Gradient_Swatch-5);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#New_Gradient_Swatch-9);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#New_Gradient_Swatch-2);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#New_Gradient_Swatch-3);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#New_Gradient_Swatch);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#New_Gradient_Swatch-13);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#New_Gradient_Swatch-10);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#New_Gradient_Swatch-19);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#New_Gradient_Swatch-12);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#New_Gradient_Swatch-11);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#New_Gradient_Swatch-14);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#New_Gradient_Swatch-18);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#New_Gradient_Swatch-17);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#New_Gradient_Swatch-16);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#New_Gradient_Swatch-15);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#New_Gradient_Swatch-29);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#New_Gradient_Swatch-26);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#New_Gradient_Swatch-21);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#New_Gradient_Swatch-24);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#New_Gradient_Swatch-25);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#New_Gradient_Swatch-27);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#New_Gradient_Swatch-23);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#New_Gradient_Swatch-28);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#New_Gradient_Swatch-22);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#New_Gradient_Swatch-20);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#New_Gradient_Swatch-31);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#New_Gradient_Swatch-30);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#New_Gradient_Swatch_copy_11);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: #2e3690;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.52,
    y1: 14.7,
    x2: 30.46,
    y2: 28.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b2452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.05,
    y1: 15.16,
    x2: 27.02,
    y2: 51.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b2452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29aae1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 29.53,
    y1: 31.61,
    x2: 37.06,
    y2: 43.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch",
    "data-name": "New Gradient Swatch",
    x1: 15.35,
    y1: -0.76,
    x2: 28.24,
    y2: 18.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b2452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_11",
    "data-name": "New Gradient Swatch copy 11",
    x1: 24.47,
    y1: 6.54,
    x2: 17.89,
    y2: 42.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 38.59,
    y1: 7.61,
    x2: 47.53,
    y2: 21.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 22.1,
    y1: 12.47,
    x2: 16.67,
    y2: 41.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-2",
    "data-name": "New Gradient Swatch",
    x1: 57.59,
    y1: 32.58,
    x2: 57.98,
    y2: 45.54,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-3",
    "data-name": "New Gradient Swatch",
    x1: 62.5,
    y1: 32.44,
    x2: 62.89,
    y2: 45.4,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-4",
    "data-name": "New Gradient Swatch",
    x1: 68.56,
    y1: 32.26,
    x2: 68.95,
    y2: 45.22,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-5",
    "data-name": "New Gradient Swatch",
    x1: 74.24,
    y1: 32.09,
    x2: 74.62,
    y2: 45.05,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-6",
    "data-name": "New Gradient Swatch",
    x1: 80.07,
    y1: 31.92,
    x2: 80.46,
    y2: 44.87,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-7",
    "data-name": "New Gradient Swatch",
    x1: 85.6,
    y1: 31.75,
    x2: 85.98,
    y2: 44.71,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-8",
    "data-name": "New Gradient Swatch",
    x1: 92.21,
    y1: 31.56,
    x2: 92.59,
    y2: 44.51,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-9",
    "data-name": "New Gradient Swatch",
    x1: 98.67,
    y1: 31.36,
    x2: 99.05,
    y2: 44.32,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-10",
    "data-name": "New Gradient Swatch",
    x1: 104.5,
    y1: 31.19,
    x2: 104.88,
    y2: 44.15,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-11",
    "data-name": "New Gradient Swatch",
    x1: 113,
    y1: 30.94,
    x2: 113.38,
    y2: 43.9,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-12",
    "data-name": "New Gradient Swatch",
    x1: 118.59,
    y1: 30.77,
    x2: 118.97,
    y2: 43.73,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-13",
    "data-name": "New Gradient Swatch",
    x1: 124.63,
    y1: 30.59,
    x2: 125.02,
    y2: 43.55,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-14",
    "data-name": "New Gradient Swatch",
    x1: 131.21,
    y1: 30.4,
    x2: 131.59,
    y2: 43.36,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-15",
    "data-name": "New Gradient Swatch",
    x1: 135.24,
    y1: 30.28,
    x2: 135.63,
    y2: 43.24,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-16",
    "data-name": "New Gradient Swatch",
    x1: 140.15,
    y1: 30.13,
    x2: 140.54,
    y2: 43.09,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-17",
    "data-name": "New Gradient Swatch",
    x1: 147.06,
    y1: 29.93,
    x2: 147.45,
    y2: 42.89,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-18",
    "data-name": "New Gradient Swatch",
    x1: 156.47,
    y1: 29.65,
    x2: 156.85,
    y2: 42.61,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-19",
    "data-name": "New Gradient Swatch",
    x1: 162.15,
    y1: 29.48,
    x2: 162.54,
    y2: 42.44,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-20",
    "data-name": "New Gradient Swatch",
    x1: 167.89,
    y1: 29.31,
    x2: 168.28,
    y2: 42.27,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-21",
    "data-name": "New Gradient Swatch",
    x1: 175.79,
    y1: 29.08,
    x2: 176.17,
    y2: 42.04,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-22",
    "data-name": "New Gradient Swatch",
    x1: 179.73,
    y1: 28.96,
    x2: 180.11,
    y2: 41.92,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-23",
    "data-name": "New Gradient Swatch",
    x1: 185.27,
    y1: 28.8,
    x2: 185.65,
    y2: 41.75,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-24",
    "data-name": "New Gradient Swatch",
    x1: 62.16,
    y1: 3.6,
    x2: 63.08,
    y2: 34.86,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-25",
    "data-name": "New Gradient Swatch",
    x1: 81.48,
    y1: 3.02,
    x2: 82.4,
    y2: 34.29,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-26",
    "data-name": "New Gradient Swatch",
    x1: 100.03,
    y1: 2.47,
    x2: 100.96,
    y2: 33.74,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-27",
    "data-name": "New Gradient Swatch",
    x1: 115.98,
    y1: 2,
    x2: 116.91,
    y2: 33.26,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-28",
    "data-name": "New Gradient Swatch",
    x1: 131.35,
    y1: 1.54,
    x2: 132.28,
    y2: 32.81,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-29",
    "data-name": "New Gradient Swatch",
    x1: 144.95,
    y1: 1.14,
    x2: 145.88,
    y2: 32.4,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-30",
    "data-name": "New Gradient Swatch",
    x1: 160.13,
    y1: 0.69,
    x2: 161.05,
    y2: 31.95,
    xlinkHref: "#New_Gradient_Swatch"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch-31",
    "data-name": "New Gradient Swatch",
    x1: 180.36,
    y1: 0.09,
    x2: 181.28,
    y2: 31.35,
    xlinkHref: "#New_Gradient_Swatch"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m23.76,15.09c2.64,0,5.2.16,7.49.45-1.11,4.33-2.96,8.85-5.35,13.04-.77,1.35-1.49,2.49-2.15,3.44-.66-.95-1.38-2.09-2.15-3.44-2.39-4.2-4.23-8.72-5.35-13.04,2.3-.29,4.86-.45,7.49-.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m22.79,46.59c-2.28-.87-6.53-4.51-11.02-12.41-3.48-6.12-5.99-12.84-7.19-19.07-.5-2.6-.78-5.11-.81-7.46C.47,10.22.59,13.98.6,14.26c.08.49.17.97.26,1.46,3.27,17.04,15.18,34.85,22.9,34.85h0c2.4,0,5.21-1.73,8.04-4.62-.06.04-4.15,2.73-9,.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m35.04,27.25c.86.21,1.72.43,2.57.68.37.11.74.22,1.11.33-.89,2.01-1.89,3.99-2.98,5.91-2.02,3.55-3.99,6.24-5.75,8.2-2.81,3.13-5.09,4.42-6.23,4.42-.26,0-.59-.07-.96-.22,4.86,2.1,8.94-.59,9-.63.33-.34.66-.69.99-1.06,3.43-3.84,6.83-9.29,9.49-15.37.21-.47.41-.95.61-1.43.38-.93-.08-1.99-1.02-2.33-.61-.22-1.23-.43-1.85-.62-.15-.05-.29-.09-.44-.14-.78-.24-1.56-.47-2.34-.68-1.39,1.17-2.19,2.92-2.19,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m42.19,2.61c-1.32-.49-2.84-.91-4.52-1.27-3.99-.86-8.85-1.33-13.92-1.33h0C11.26,0,0,2.89,0,7.26c0,2.27.21,4.62.6,6.99-.01-.27-.13-4.04,3.17-6.61.5-.48,2.19-1.53,6.03-2.44,3.9-.92,8.85-1.43,13.95-1.43s10.05.51,13.95,1.43c.02,0,.03,0,.05.01,3.81.91,5.49,1.95,5.98,2.43-.02-3.03-1.54-5.03-1.54-5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m38.88,16.07c.5-2.17.83-4.28.99-6.28-.69-.27-1.67-.59-3.03-.92-3.62-.86-8.26-1.33-13.08-1.33s-9.46.47-13.08,1.33c-1.36.32-2.35.65-3.03.92.54,6.96,3.24,15.2,7.4,22.52,4,7.02,7.41,9.83,8.71,10.57,1.29-.74,4.71-3.55,8.71-10.57.94-1.65,1.8-3.35,2.58-5.06,0,0,.8-1.75,2.19-2.92-.29-.08-.57-.15-.86-.22-.64-.16-1.28-.3-1.92-.44-1.03-.22-2.09.32-2.51,1.29-.22.51-.46,1.02-.69,1.52-.63,1.34-1.32,2.67-2.06,3.97-2.2,3.87-4.11,6.2-5.43,7.55-1.31-1.34-3.23-3.68-5.43-7.55-3.31-5.81-5.62-12.19-6.56-17.95,3.31-.76,7.56-1.18,11.99-1.18s8.67.42,11.99,1.18c-.2,1.21-.45,2.44-.77,3.69-.15.61-.32,1.23-.5,1.85-.29.98.32,2,1.32,2.22.6.13,1.24.28,1.71.39.77-2.07,1.37-4.57,1.37-4.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m42.19,2.61s1.53,2.01,1.54,5.04c-.04,3.23-.55,6.76-1.46,10.4-.45-.14-.89-.28-1.34-.41-.76-.22-1.53-.44-2.3-.63,0,0-.44,1.76-1.13,3.63.03,0,.07.02.1.03,0,0,0,0,0,0,.82.21,1.64.44,2.45.68.39.12.79.24,1.18.36h0c.42.14.84.28,1.26.42.32.11.63.22.95.33.05.02.11.04.16.06,0,0,0,0,.01,0,.64.23,1.35-.12,1.55-.77.25-.82.48-1.63.69-2.45,1.05-4.06,1.67-8.16,1.67-12.03,0-1.86-2.03-3.44-5.32-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m38.66,16.98s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m23.76,42.88c1.29-.74,4.71-3.55,8.71-10.57.49-.85.95-1.72,1.4-2.6-2.98,5.53-10.1,11.9-10.1,11.9C10.93,30.19,7.65,9.79,7.65,9.79c.54,6.96,3.24,15.2,7.4,22.52,4,7.02,7.41,9.83,8.71,10.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m58.24,35.83v5.47h-.94v-5.47h.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m65.13,35.83v5.75l-4-3.95v3.67h-.91v-5.75l4,3.95v-3.67h.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m67.88,40.09c.14.16.29.28.46.37.17.09.36.13.56.13.25,0,.45-.07.61-.2.16-.13.23-.31.23-.53,0-.2-.05-.36-.14-.48-.1-.12-.23-.23-.41-.31-.18-.09-.38-.17-.61-.25-.14-.05-.29-.11-.45-.19s-.33-.18-.48-.3c-.15-.12-.28-.27-.38-.45-.1-.18-.15-.4-.15-.65,0-.29.08-.55.23-.77.15-.22.36-.39.61-.52s.55-.19.88-.19.6.06.84.18c.24.12.44.26.61.44.17.18.29.36.38.56l-.74.42c-.07-.14-.16-.26-.27-.38-.1-.12-.23-.21-.36-.28-.14-.07-.3-.11-.48-.11-.26,0-.44.06-.56.18-.12.12-.18.25-.18.41,0,.14.04.27.13.38s.22.22.4.32c.18.1.42.2.71.31.17.06.33.13.5.22.17.09.31.2.45.33.13.13.24.29.32.46.08.18.12.39.12.63,0,.25-.05.48-.15.69-.1.2-.24.37-.41.51-.17.14-.37.25-.58.32-.22.08-.44.11-.68.11-.32,0-.61-.06-.89-.19s-.51-.3-.72-.51c-.21-.21-.37-.45-.49-.7l.69-.48c.12.21.25.4.39.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.33,35.83v3.64c0,.33.09.6.27.81.18.21.45.31.8.31s.62-.1.8-.31c.18-.21.27-.48.27-.81v-3.64h.93v3.67c0,.3-.05.57-.14.81-.1.24-.23.44-.41.61s-.39.29-.64.38c-.25.09-.51.13-.81.13s-.56-.04-.81-.13-.46-.22-.63-.38c-.18-.17-.31-.37-.41-.61-.1-.24-.15-.51-.15-.81v-3.67h.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m79.28,35.83v5.47h-.92v-5.47h.92Zm-.38,0h1.14c.4,0,.75.07,1.04.21.29.14.52.34.68.59.16.25.25.55.25.9s-.08.64-.25.9c-.16.25-.39.45-.68.59-.29.14-.64.21-1.04.21h-1.14v-.77h1.1c.21,0,.4-.04.55-.11s.28-.17.37-.31c.09-.14.13-.3.13-.5s-.04-.36-.13-.5c-.09-.14-.21-.24-.37-.31-.16-.07-.34-.11-.55-.11h-1.1v-.8Zm1.58,2.86l1.86,2.61h-1.12l-1.74-2.61h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.02,39.39l-.02.2-.76,1.71h-1.04l2.67-5.78,2.68,5.78h-1.05l-.74-1.67-.02-.23-.88-2.03-.86,2.01Zm-.39-.27h2.54l.17.78h-2.89l.18-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.87,35.83v5.75l-4-3.95v3.67h-.91v-5.75l4,3.95v-3.67h.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m97.82,39.58c.17.29.4.51.68.68.28.16.59.24.92.24.26,0,.5-.03.71-.1.21-.07.4-.16.57-.28s.31-.25.44-.4v1.1c-.22.19-.47.33-.74.43s-.6.15-1,.15-.78-.07-1.12-.2c-.35-.14-.65-.33-.9-.59-.26-.25-.46-.56-.6-.9-.14-.35-.21-.73-.21-1.14s.07-.8.21-1.15c.14-.35.34-.65.6-.9.25-.25.56-.45.9-.59.35-.14.72-.21,1.12-.21s.74.05,1,.15.51.25.74.44v1.09c-.12-.15-.27-.28-.44-.39s-.36-.21-.57-.28c-.21-.07-.45-.1-.71-.1-.33,0-.64.08-.92.24-.28.16-.51.38-.68.67s-.26.63-.26,1.02.09.72.26,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m103.96,35.83v5.47h-.91v-5.47h.91Zm-.34,0h2.76v.81h-2.76v-.81Zm0,2.14h2.6v.8h-2.6v-.8Zm0,2.52h2.76v.81h-2.76v-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m112.13,38.03h.88c.17,0,.32-.03.45-.09.13-.06.23-.14.3-.25.07-.11.11-.24.11-.39,0-.23-.08-.41-.24-.53s-.37-.19-.63-.19h-.67v3.95h.77c.21,0,.39-.03.55-.1.16-.07.29-.17.38-.3.09-.13.14-.3.14-.5,0-.15-.03-.28-.08-.39-.05-.11-.13-.2-.23-.28-.1-.08-.21-.13-.34-.16s-.27-.05-.43-.05h-.99v-.52h1.04c.27,0,.52.03.75.09.24.06.45.15.63.27s.33.27.43.46.16.41.16.67c0,.36-.08.66-.25.89-.17.24-.4.41-.69.52-.29.11-.64.17-1.03.17h-1.74v-5.47h1.65c.35,0,.65.05.91.15s.47.25.61.45.22.46.22.77c0,.27-.07.5-.22.69-.15.19-.35.33-.61.43-.26.1-.57.15-.91.15h-.95v-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m117.83,35.83v5.47h-.92v-5.47h.92Zm-.38,0h1.14c.4,0,.75.07,1.04.21.29.14.52.34.68.59.16.25.25.55.25.9s-.08.64-.25.9c-.16.25-.39.45-.68.59-.29.14-.64.21-1.04.21h-1.14v-.77h1.1c.21,0,.4-.04.55-.11s.28-.17.37-.31c.09-.14.13-.3.13-.5s-.04-.36-.13-.5c-.09-.14-.21-.24-.37-.31-.16-.07-.34-.11-.55-.11h-1.1v-.8Zm1.58,2.86l1.86,2.61h-1.12l-1.74-2.61h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m122.24,37.44c.14-.34.34-.64.6-.9.26-.25.56-.45.91-.59.35-.14.72-.21,1.12-.21s.79.07,1.13.21.65.34.9.59c.26.25.46.55.6.9s.21.72.21,1.13-.07.78-.21,1.13c-.14.35-.34.65-.59.91s-.56.46-.9.6-.72.21-1.14.21-.78-.07-1.13-.21c-.35-.14-.65-.34-.9-.6-.26-.25-.45-.56-.59-.91-.14-.35-.21-.73-.21-1.13s.07-.79.21-1.13Zm1.01,2.13c.16.29.38.52.66.69.28.17.6.25.96.25s.69-.08.97-.25c.28-.17.5-.4.66-.69.16-.29.24-.63.24-1s-.08-.71-.23-1c-.16-.29-.37-.52-.65-.69-.28-.17-.6-.25-.97-.25s-.68.08-.96.25c-.28.17-.5.4-.66.69-.16.29-.24.63-.24,1s.08.71.24,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m130.35,35.83v5.47h-.95v-5.47h.95Zm3.15,0l-2.31,2.56,2.43,2.91h-1.14l-2.4-2.88,2.31-2.59h1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m135.96,35.83v5.47h-.94v-5.47h.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m142.85,35.83v5.75l-4-3.95v3.67h-.91v-5.75l4,3.95v-3.67h.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m147.46,38.44h2.63c.01.4-.04.78-.16,1.14-.11.36-.29.67-.52.95-.23.28-.51.49-.85.65s-.73.24-1.17.24c-.41,0-.79-.07-1.14-.21-.35-.14-.65-.33-.91-.59-.26-.25-.46-.56-.6-.91-.14-.35-.21-.73-.21-1.15s.07-.8.21-1.15c.14-.35.35-.65.61-.9.26-.25.57-.45.92-.59.35-.14.73-.21,1.14-.21.36,0,.69.05.98.15.29.1.56.24.79.42s.42.4.59.65l-.75.5c-.15-.26-.36-.47-.63-.62s-.59-.24-.97-.24c-.35,0-.67.08-.96.25-.29.16-.52.39-.69.69-.17.29-.25.64-.25,1.04s.08.74.25,1.04.39.53.68.7c.29.17.61.25.97.25.25,0,.46-.03.66-.1.19-.07.36-.16.5-.29s.26-.27.35-.43c.09-.16.16-.33.21-.52h-1.68v-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m155.87,35.83v5.47h-.92v-5.47h.92Zm-.38,0h1.1c.4,0,.75.07,1.04.21.29.14.52.33.68.59.16.25.25.55.25.9s-.08.65-.25.91c-.16.25-.39.45-.68.59-.29.14-.64.21-1.04.21h-1.1v-.81h1.1c.32,0,.57-.08.77-.23.19-.15.29-.37.29-.67s-.1-.51-.29-.66c-.19-.15-.45-.22-.77-.22h-1.1v-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m163.95,35.83h1.07l-2.68,5.78-2.67-5.78h1.06l1.61,3.85,1.61-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m166.19,35.83h3.82v.85h-1.45v4.62h-.92v-4.62h-1.45v-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m175.51,35.83v4.64h2.17v.83h-3.1v-5.47h.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m178.04,35.83h3.82v.85h-1.45v4.62h-.92v-4.62h-1.45v-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m184.25,35.83v5.47h-.95v-5.47h.95Zm-.38,5.47v-.87h1.17c.27,0,.52-.04.75-.12.23-.08.43-.2.6-.35.17-.15.3-.35.4-.58.1-.24.14-.51.14-.81s-.05-.58-.14-.81c-.1-.23-.23-.43-.4-.59-.17-.16-.37-.27-.6-.35s-.48-.12-.75-.12h-1.17v-.87h1.2c.56,0,1.05.11,1.47.34s.75.54.99.95c.24.41.36.89.36,1.44s-.12,1.03-.36,1.44c-.24.41-.57.73-.99.95s-.91.34-1.47.34h-1.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m59.18,23.48c.57.94,1.32,1.68,2.23,2.21.92.53,1.92.79,3.01.79.85,0,1.62-.11,2.31-.33.69-.22,1.31-.52,1.85-.91s1.02-.82,1.43-1.32v3.6c-.73.61-1.54,1.08-2.41,1.4-.88.32-1.97.49-3.28.49s-2.53-.22-3.66-.66c-1.13-.44-2.12-1.08-2.95-1.92s-1.49-1.82-1.95-2.95c-.47-1.13-.7-2.37-.7-3.71s.23-2.61.7-3.74c.47-1.13,1.12-2.11,1.95-2.94.83-.83,1.82-1.46,2.95-1.92,1.13-.45,2.35-.68,3.66-.68s2.4.16,3.28.49c.88.32,1.68.8,2.41,1.43v3.58c-.41-.48-.89-.91-1.43-1.29-.54-.38-1.16-.69-1.85-.91-.69-.22-1.46-.33-2.31-.33-1.09,0-2.09.26-3.01.78s-1.66,1.25-2.23,2.2c-.57.95-.86,2.06-.86,3.33s.29,2.36.86,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m73.39,16.47c.46-1.12,1.11-2.1,1.95-2.92.84-.83,1.83-1.47,2.96-1.94,1.13-.47,2.35-.7,3.66-.7s2.58.23,3.7.7c1.12.47,2.11,1.12,2.95,1.94.84.83,1.49,1.8,1.95,2.92.46,1.12.69,2.36.69,3.7s-.23,2.56-.69,3.7c-.46,1.14-1.11,2.13-1.94,2.96s-1.81,1.49-2.94,1.95c-1.12.47-2.37.7-3.73.7s-2.56-.23-3.69-.7c-1.13-.47-2.12-1.12-2.95-1.95-.83-.83-1.48-1.82-1.94-2.96-.46-1.14-.69-2.38-.69-3.7s.23-2.58.69-3.7Zm3.29,6.97c.53.95,1.25,1.71,2.16,2.26.91.55,1.95.83,3.13.83s2.24-.28,3.15-.83c.91-.55,1.62-1.31,2.14-2.26.52-.95.78-2.04.78-3.27s-.26-2.32-.77-3.28-1.22-1.71-2.13-2.26c-.91-.54-1.97-.82-3.18-.82s-2.22.27-3.13.82c-.91.54-1.63,1.3-2.16,2.26-.53.96-.79,2.06-.79,3.28s.26,2.31.79,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m105.54,11.24h3.5l-8.76,18.87-8.73-18.87h3.47l5.26,12.56,5.26-12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m114.04,11.24v17.87h-2.96V11.24h2.96Zm-1.1,0h9.01v2.66h-9.01v-2.66Zm0,7h8.5v2.6h-8.5v-2.6Zm0,8.22h9.01v2.66h-9.01v-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m128.67,11.24v17.87h-3.01V11.24h3.01Zm-1.23,0h3.73c1.31,0,2.44.23,3.4.69.95.46,1.7,1.1,2.23,1.93.54.83.8,1.8.8,2.92s-.27,2.1-.8,2.94c-.54.83-1.28,1.48-2.23,1.94-.95.46-2.09.69-3.4.69h-3.73v-2.5h3.6c.7,0,1.3-.12,1.81-.34.51-.23.91-.57,1.2-1.02.29-.45.43-.99.43-1.62s-.14-1.19-.43-1.63c-.29-.44-.69-.78-1.2-1.02-.51-.24-1.12-.36-1.81-.36h-3.6v-2.6Zm5.16,9.35l6.08,8.53h-3.65l-5.67-8.53h3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m139.06,11.24h12.46v2.78h-4.72v15.09h-3.01v-15.09h-4.72v-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m152.11,16.47c.46-1.12,1.11-2.1,1.95-2.92.84-.83,1.83-1.47,2.96-1.94,1.13-.47,2.35-.7,3.66-.7s2.58.23,3.7.7c1.12.47,2.11,1.12,2.95,1.94.84.83,1.49,1.8,1.95,2.92.46,1.12.69,2.36.69,3.7s-.23,2.56-.69,3.7c-.46,1.14-1.11,2.13-1.94,2.96s-1.81,1.49-2.94,1.95c-1.12.47-2.37.7-3.73.7s-2.56-.23-3.69-.7c-1.13-.47-2.12-1.12-2.95-1.95-.83-.83-1.48-1.82-1.94-2.96-.46-1.14-.69-2.38-.69-3.7s.23-2.58.69-3.7Zm3.29,6.97c.53.95,1.25,1.71,2.16,2.26.91.55,1.95.83,3.13.83s2.24-.28,3.15-.83c.91-.55,1.62-1.31,2.14-2.26.52-.95.78-2.04.78-3.27s-.26-2.32-.77-3.28-1.22-1.71-2.13-2.26c-.91-.54-1.97-.82-3.18-.82s-2.22.27-3.13.82c-.91.54-1.63,1.3-2.16,2.26-.53.96-.79,2.06-.79,3.28s.26,2.31.79,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m188.96,11.24v18.77l-13.05-12.89v12h-2.96V10.35l13.05,12.89v-12h2.96Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverton);
export default __webpack_public_path__ + "static/media/Coverton.bbd0ba4349308d29e1a16ec174cdf78b.svg";
export { ForwardRef as ReactComponent };